import React, { useContext, useEffect, useState } from "react";
import db from "../../services/query";
import { AuthContext } from "../../contexts/authContext";
import { setUserPositionId } from "../../utils/financeAccess";

const QaRoleSwitcher = () => {
  const { accountProfile, refreshAuth } = useContext(AuthContext);
  const [roles, setRoles] = useState([]);
  const [currentId, setCurrentId] = useState(0);
  const [busy, setBusy] = useState(false);

  const allowed =
    accountProfile?.qa_role_switch_allowed === true ||
    accountProfile?.qa_role_switch_allowed === 1;

  useEffect(() => {
    if (!allowed) return undefined;
    let cancelled = false;
    (async () => {
      try {
        const res = await db.getAll("login/qa/roles");
        const payload = res?.data || {};
        if (cancelled) return;
        setRoles(Array.isArray(payload.data) ? payload.data : []);
        setCurrentId(Number(payload.current_role_id || accountProfile?.position_id || 0));
      } catch (_e) {
        if (!cancelled) setRoles([]);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [allowed, accountProfile?.position_id]);

  if (!allowed) {
    return null;
  }

  const handleChange = async (e) => {
    const roleId = e.target.value;
    if (!roleId || busy || String(roleId) === String(currentId)) {
      return;
    }
    const label = e.target.options[e.target.selectedIndex]?.text || roleId;
    const ok = window.confirm(`نقش به «${label}» تغییر کند؟ صفحه تازه می‌شود.`);
    if (!ok) {
      e.target.value = String(currentId || "");
      return;
    }
    setBusy(true);
    try {
      const res = await db.save("login/qa/switch-role", { role_id: roleId });
      const body = res?.data || {};
      if (body.ok) {
        setUserPositionId(Number(roleId));
        if (typeof refreshAuth === "function") {
          await refreshAuth();
        }
        window.location.reload();
        return;
      }
      window.alert(body.message || "تغییر نقش انجام نشد.");
    } catch (_err) {
      window.alert("تغییر نقش انجام نشد.");
    } finally {
      setBusy(false);
      e.target.value = String(currentId || "");
    }
  };

  return (
    <div className="qa-role-switcher" title="تست نقش — فقط حساب QA">
      <label htmlFor="qa-role-select">تست نقش</label>
      <select
        id="qa-role-select"
        disabled={busy || !roles.length}
        value={String(currentId || "")}
        onChange={handleChange}
      >
        {!roles.length ? (
          <option value="">…</option>
        ) : (
          roles.map((role) => (
            <option key={role.role_id} value={role.role_id}>
              {role.position_title || role.role} ({role.role_id})
            </option>
          ))
        )}
      </select>
    </div>
  );
};

export default QaRoleSwitcher;
